// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2lt3A","productName":"Table_productName__2bR4-"};